import { useCallback, useState } from 'react';
import { batch } from 'react-redux';

import * as St from './StoresList.styles';

import { useStoresContext } from '~/legacy/easy-estimator-page/context/storesContext';
import { useAppDispatch } from '~/redux/hooks';
import { updateIsNewEstimate } from '~/redux/slices/estimate';
import { updateZipcode } from '~/redux/slices/zipcode';
import RetailStores from '~organisms/RetailStores';
import RetailStoresMap from '~organisms/RetailStoresMap';
import StoreChangeModal from '~organisms/StoreChangeModal';
import StoreSearch from '~templates/StoreSearch';

const StoresList = () => {
  const dispatch = useAppDispatch();
  const [isZipModalVisible, setIsZipModalVisible] = useState(false);
  const [newZipCode, setNewZipCode] = useState<string>();

  const {
    getters: { googleMapsApiKey, googleMapsMapId, zipCodeLocation, stores },
  } = useStoresContext();

  const closeZipModal = () => {
    setIsZipModalVisible(false);
  };

  const onConfirmChangingZipCodeFromModal = useCallback(() => {
    if (newZipCode) {
      dispatch(updateZipcode(newZipCode));
    }

    closeZipModal();
  }, [dispatch, newZipCode]);

  const showMap =
    Boolean(googleMapsApiKey) &&
    Boolean(googleMapsMapId) &&
    Boolean(zipCodeLocation) &&
    !!stores.length;

  return (
    <St.Container>
      <StoreSearch
        onSubmitWithNonEmptyDrawingArea={(newZipcode) => {
          setNewZipCode(newZipcode);
          setIsZipModalVisible(true);
        }}
        onSubmitWithEmptyDrawingArea={(newZipcode) => {
          batch(() => {
            dispatch(updateZipcode(newZipcode));
            dispatch(updateIsNewEstimate(true));
          });
        }}
      >
        <RetailStores />
      </StoreSearch>
      {showMap && (
        <St.MapContainer>
          <RetailStoresMap />
        </St.MapContainer>
      )}
      <StoreChangeModal
        newZipCode={newZipCode}
        isVisible={isZipModalVisible}
        handleClose={closeZipModal}
        handleChange={onConfirmChangingZipCodeFromModal}
      />
    </St.Container>
  );
};

export default StoresList;
